//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        active: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        tooltip: {
            type: String,
            default: ''
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        scale: {
            type: Number,
            default: 1
        },
        iconWidth: {
            type: Number,
            default: 60
        }
    },

    data () {
        return {
            hover: false
        };
    }
};
